/** Resolve a logical column to the actual cell covering it (section labels span the row). */
export function renderedCellIndex(columnIndex: number, spans: number[]): number {
  for (let start = 0; start < spans.length; ) {
    const span = Math.max(1, Math.min(spans.length - start, Math.trunc(spans[start] || 1)));
    if (columnIndex < start + span) return start;
    start += span;
  }
  return Math.max(0, spans.length - 1);
}
